// extracted by mini-css-extract-plugin
export default {"button":"ko-z","reviewSort":"lo-z"};